import {Component, Input, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {CommonModule} from '@angular/common';
import {ArticleService} from '../../../core/services/article/article.service';
import {ArticleDetail} from '../../../core/models/article/article-detail.model';
import {TranslateModule} from '@ngx-translate/core';
import {DomSanitizer, SafeHtml, Title} from '@angular/platform-browser';

@Component({
  selector: 'app-article-detail',
  imports: [
    CommonModule,
    TranslateModule
  ],
  templateUrl: './article-detail.component.html',
  styleUrl: './article-detail.component.scss'
})
export class ArticleDetailComponent implements OnInit {

  @Input() articleId!: number;
  @Input() pageName!: string;

  data: ArticleDetail | null = null;
  loading: boolean = false;
  error: string | null = null;

  safeContent!: SafeHtml;

  constructor(
    private readonly articleService: ArticleService,
    private readonly route: ActivatedRoute,
    private readonly router: Router,
    private readonly title: Title,
    private readonly sanitizer: DomSanitizer
  ) {}

  ngOnInit(): void {
    // Subscribe to route params to get articleId from URL path parameter
    this.route.params.subscribe(params => {
      if (params['articleId']) {
        this.articleId = +params['articleId']; // Convert to number
      }

      // If articleId is not in params, check route data
      if (!this.articleId) {
        this.route.data.subscribe((data) => {
          this.pageName = data['pageName'] || 'DEFAULT_TITLE';
          if (data['articleId']) {
            this.articleId = data['articleId'];
          }

          // If articleId is still not available, redirect to not-found
          if (!this.articleId) {
            this.router.navigate(['/not-found']);
            return;
          }

          this.loadArticle();
        });
      } else {
        // If we got articleId from params, still need to get pageName from data
        this.route.data.subscribe((data) => {
          this.pageName = data['pageName'] || 'DEFAULT_TITLE';
        });

        this.loadArticle();
      }
    });
  }

  loadArticle(): void {
    // We should never reach this point without an articleId
    // because we redirect to /not-found if articleId is not available
    this.loading = true;
    this.error = null;

    this.articleService.getArticleById(this.articleId)
      .subscribe({
        next: (article) => {
          this.data = article;
          this.safeContent = this.sanitizer.bypassSecurityTrustHtml(article.content);
          this.title.setTitle(`${article.title} - World Conquer Online`);
          this.loading = false;
        },
        error: (err) => {
          console.error('Error loading article', err);
          this.error = 'Error loading article. Please try again later.';
          this.loading = false;
        }
      });
  }
}
